































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { storeBedManagement } from "@/store/modules/BedManagementStore";
import BedManagementSvc from "@/services/BedManagementService";
import { userModule } from "@/store/modules/user";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import CheckboxGroupSlug from "@/components/pemeriksaan/assesmen/geriatri/CheckboxGroupSlug.vue";
import { localISODate } from "@/utils/localDate";
import { composeDate, toDateString, toTimeString } from "@/utils/asesmenIntensifDateTime";
import {
  BedManagementChecklist,
  BedManagementMasters,
  BedManagementPayload
} from "@/types/bedManagement";

const NAMA_HARI = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
const MASTERS_KOSONG: BedManagementMasters = { problem: [], tatalaksana: [], evaluasi: [] };

interface ChecklistDraft {
  pilihan: string[];
  lainnya: string;
}

@Component({ components: { VCDateTimePicker, UnitRuangPicker, CheckboxGroupSlug } })
export default class BedManagementFormPage extends Vue {
  form = {
    tanggal: localISODate(),
    pukul: toTimeString(new Date()),
    unit_terkait: [] as string[],
    problem: { pilihan: [], lainnya: "" } as ChecklistDraft,
    tatalaksana: { pilihan: [], lainnya: "" } as ChecklistDraft
  };
  evaluasiDraft: ChecklistDraft = { pilihan: [], lainnya: "" };

  maxWaktu = new Date();
  saving = false;
  savingEvaluasi = false;
  menghapus = false;
  dialogHapus = false;
  snackbar = false;
  snackbarText = "";
  snackbarColor = "success";

  get routeId() {
    return this.$route.params.id;
  }

  get isNew() {
    return this.routeId === "baru";
  }

  get current() {
    return storeBedManagement.currentItem;
  }

  get masters(): BedManagementMasters {
    return storeBedManagement.masters || MASTERS_KOSONG;
  }

  get canEdit(): boolean {
    if (this.isNew) return userModule.hasPrivilege("mpp_bed_management", "create");
    return !!(this.current && this.current.can_edit);
  }

  get mppNama(): string {
    if (this.current && this.current.mpp) return this.current.mpp.nama || "";
    return userModule.user?.nama || "";
  }

  get waktu(): Date | null {
    return composeDate(this.form.tanggal, this.form.pukul);
  }

  set waktu(val: Date | null) {
    this.form.tanggal = toDateString(val) || "";
    this.form.pukul = toTimeString(val);
  }

  get hariLabel(): string {
    if (this.current && this.current.hari && this.current.tanggal === this.form.tanggal) {
      return this.current.hari;
    }
    const [y, m, d] = (this.form.tanggal || "").split("-").map(Number);
    if (!y || !m || !d) return "";
    return NAMA_HARI[new Date(y, m - 1, d).getDay()] || "";
  }

  async mounted() {
    await storeBedManagement.fetchMasters();
    if (!this.isNew) {
      await this.load();
    }
  }

  @Watch("$route.params.id")
  async onRouteIdChange(newId: string) {
    if (newId && newId !== "baru") {
      await this.load();
    }
  }

  async load() {
    await storeBedManagement.refresh(Number(this.routeId));
    const c = this.current;
    if (!c) return;
    this.form = {
      tanggal: c.tanggal || localISODate(),
      pukul: c.pukul || "",
      unit_terkait: (c.unit_terkait || []).map(u => u.id),
      problem: this.draftDari(c.problem),
      tatalaksana: this.draftDari(c.tatalaksana)
    };
    this.evaluasiDraft = this.draftDari(c.evaluasi);
  }

  draftDari(checklist: BedManagementChecklist | null): ChecklistDraft {
    return {
      pilihan: checklist && Array.isArray(checklist.pilihan) ? [...checklist.pilihan] : [],
      lainnya: (checklist && checklist.lainnya) || ""
    };
  }

  payloadDari(draft: ChecklistDraft): BedManagementChecklist {
    const lainnya = (draft.lainnya || "").trim();
    return { pilihan: [...draft.pilihan], lainnya: lainnya === "" ? null : lainnya };
  }

  adaIsian(draft: ChecklistDraft): boolean {
    return draft.pilihan.length > 0 || (draft.lainnya || "").trim() !== "";
  }

  tampilkan(text: string, color = "success") {
    this.snackbarText = text;
    this.snackbarColor = color;
    this.snackbar = true;
  }

  async simpan() {
    if (!this.form.tanggal || !this.form.pukul) {
      this.tampilkan("Tanggal & pukul wajib diisi", "error");
      return;
    }
    if (this.form.unit_terkait.length === 0) {
      this.tampilkan("Pilih minimal satu unit terkait", "error");
      return;
    }
    if (!this.adaIsian(this.form.problem)) {
      this.tampilkan("Pilih minimal satu problem atau isi kolom Lainnya", "error");
      return;
    }

    const payload: BedManagementPayload = {
      tanggal: this.form.tanggal,
      pukul: this.form.pukul,
      unit_terkait: [...this.form.unit_terkait],
      problem: this.payloadDari(this.form.problem),
      tatalaksana: this.payloadDari(this.form.tatalaksana)
    };

    this.saving = true;
    try {
      if (this.isNew) {
        const resp = await BedManagementSvc.create(payload);
        const id = resp.data.data.id;
        this.tampilkan("Catatan bed management tersimpan");
        this.$router.replace({ name: "bed-management-form", params: { id: String(id) } });
      } else if (this.current) {
        await BedManagementSvc.update(this.current.id, payload);
        await this.load();
        this.tampilkan("Catatan bed management diperbarui");
      }
    } catch {
      // ErrorAlert sudah tampil dari service
    } finally {
      this.saving = false;
    }
  }

  async simpanEvaluasi() {
    if (!this.current) return;
    if (!this.adaIsian(this.evaluasiDraft)) {
      this.tampilkan("Pilih minimal satu evaluasi atau isi kolom Lainnya", "error");
      return;
    }
    this.savingEvaluasi = true;
    try {
      await BedManagementSvc.updateEvaluasi(this.current.id, this.payloadDari(this.evaluasiDraft));
      await this.load();
      this.tampilkan("Evaluasi tersimpan");
    } catch {
      // ErrorAlert sudah tampil dari service
    } finally {
      this.savingEvaluasi = false;
    }
  }

  async hapus() {
    if (!this.current) return;
    this.menghapus = true;
    try {
      await BedManagementSvc.destroy(this.current.id);
      this.dialogHapus = false;
      this.$router.push({ name: "bed-management-list" });
    } catch {
      // ErrorAlert sudah tampil dari service
    } finally {
      this.menghapus = false;
    }
  }

  printPdf() {
    if (this.current) BedManagementSvc.printPdf(this.current.id);
  }

  back() {
    this.$router.push({ name: "bed-management-list" });
  }

  formatDt(dt: string | null) {
    if (!dt) return "";
    const [tanggal, jam] = dt.split(" ");
    const [y, m, d] = (tanggal || "").split("-");
    return `${d}-${m}-${y} ${(jam || "").substring(0, 5)}`;
  }
}
